module.exports = __webpack_public_path__ + "static/binder5-461036cbd7dea8e36a0fe29ff2afc31d.png";